export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: any; output: any };
  Locale: { input: any; output: any };
  ProductIdentifier: { input: any; output: any };
  _FieldSet: { input: any; output: any };
};

export type Accordion = {
  __typename?: 'Accordion';
  content: AccordionContent;
  expanded?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

/**
 *  ShopTheItems replaces VariantShopTheLook for products without shop-the-look items.
 *  FE renders the appropriate one based on product data.
 */
export type AccordionContent =
  | AttributeGroups
  | Fit
  | Ingredients
  | ProductDescription
  | ReturnOldProduct
  | ShopTheItems
  | VariantShopTheLook
  | WashingInstructions;

export type Address = {
  __typename?: 'Address';
  cityName: Scalars['String']['output'];
  number: Scalars['String']['output'];
  numberSuffix?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
};

export type AlternativeUrl = {
  locale: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AttributeGroup = {
  __typename?: 'AttributeGroup';
  attributes: Array<ProductAttribute>;
  key: AttributeGroupKey;
  label: Scalars['String']['output'];
};

export enum AttributeGroupKey {
  Composition = 'COMPOSITION',
  Fit = 'FIT',
  Ingredients = 'INGREDIENTS',
  OldProductReturn = 'OLD_PRODUCT_RETURN',
  Specifications = 'SPECIFICATIONS',
  WashingInstructions = 'WASHING_INSTRUCTIONS',
}

/**
 * Content of the combined "composition & specifications" accordion: a list of labeled attribute
 * groups shown together inside a single accordion. Today those are the `composition` and
 * `specifications` groups. Which groups appear here is a presentation decision owned by luna
 * (see `AccordionsService`) and may change in the future.
 */
export type AttributeGroups = {
  __typename?: 'AttributeGroups';
  groups?: Maybe<Array<AttributeGroup>>;
};

export enum AttributesDisplayMode {
  Children = 'CHILDREN',
  Cosmetics = 'COSMETICS',
  Food = 'FOOD',
  Living = 'LIVING',
  Other = 'OTHER',
}

export type Availability = {
  __typename?: 'Availability';
  /** @deprecated Please use 'purchasable' */
  available: Scalars['Boolean']['output'];
  /** @deprecated Please use 'purchasableInFuture' */
  availableFuture: Scalars['Boolean']['output'];
  /** @deprecated Please remove this in your query */
  buyableFromDate: Scalars['Float']['output'];
  /** Whether this product is only available online. */
  onlineOnly: Scalars['Boolean']['output'];
  purchasable: Scalars['Boolean']['output'];
  purchasableInFuture: Scalars['Boolean']['output'];
  stock: Scalars['Int']['output'];
};

export type Banner = {
  __typename?: 'Banner';
  bannerContent?: Maybe<BannerContent>;
  id: Scalars['ID']['output'];
  position: BannerPosition;
};

export type BannerContent = {
  __typename?: 'BannerContent';
  description?: Maybe<Scalars['String']['output']>;
  image: ImageModel;
  link?: Maybe<Link>;
  logo?: Maybe<ImageModel>;
  signing?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export enum BannerPosition {
  Bottom = 'BOTTOM',
  Inlister = 'INLISTER',
  Top = 'TOP',
}

export type Brand = {
  __typename?: 'Brand';
  name?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  relativeUrl?: Maybe<Scalars['String']['output']>;
};

export type BrandContent = {
  __typename?: 'BrandContent';
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new?: Maybe<Scalars['Boolean']['output']>;
};

export type BrandRecommendation = {
  __typename?: 'BrandRecommendation';
  brands: Array<BrandContent>;
  category: Scalars['String']['output'];
  variant?: Maybe<Scalars['String']['output']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  id: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  noFollow: Scalars['Boolean']['output'];
  query: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Breadcrumb entry exposed by the new product-detail-page and lister-page queries. */
export type BreadcrumbV2 = {
  __typename?: 'BreadcrumbV2';
  name: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**  Hours in which the store is open. It provides more formatting options when compared to the OpeningsHours object. */
export type BusinessHours = {
  __typename?: 'BusinessHours';
  /**
   * Openings hours of the current week.
   * Also includes past days of the week.
   */
  currentWeek: BusinessHoursWeek;
  /**
   * Openings hours of the next week.
   * This is the furthest date we are comfortable showing to the customer.
   */
  nextWeek: BusinessHoursWeek;
  /**
   * Title to show on any view to show that this contains openings hours.
   * E.g. Openingstijden
   */
  title: Scalars['String']['output'];
};

/**  Openings hour information for a specific day.  */
export type BusinessHoursDay = {
  __typename?: 'BusinessHoursDay';
  /**  Abbreviated name of the day.  */
  abbreviatedName?: Maybe<Scalars['String']['output']>;
  /**  Indicates if it is the current day.  */
  currentDay?: Maybe<Scalars['Boolean']['output']>;
  /**  Date of the day. yyyy-mm-dd  */
  date?: Maybe<Scalars['String']['output']>;
  /**  Full name of the day.  */
  dayName: Scalars['String']['output'];
  /**  The text representation of the openings times.  */
  display: Scalars['String']['output'];
};

/**  A week overview of the openings times of a store. Starts on monday and ends on sunday. */
export type BusinessHoursWeek = {
  __typename?: 'BusinessHoursWeek';
  /**  Displays the date range from the start of the week to the end.  */
  dateLine?: Maybe<Scalars['String']['output']>;
  /**  The openings hours for the thursday of the week.  */
  fr: BusinessHoursDay;
  /**  The openings hours for the monday of the week.  */
  mo: BusinessHoursDay;
  /**  The openings hours for the saturday of the week.  */
  sa: BusinessHoursDay;
  /**  The openings hours for the sunday of the week.  */
  su: BusinessHoursDay;
  /**  The openings hours for the wednesday of the week.  */
  th: BusinessHoursDay;
  /**  The openings hours for the tuesday of the week.  */
  tu: BusinessHoursDay;
  /**  The openings hours for the wednesday of the week.  */
  we: BusinessHoursDay;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

/**
 *  Simplified representation of a product for use in carousels.
 *  Carousels don't need variant data, so variants are excluded here
 */
export type CarouselProduct = {
  __typename?: 'CarouselProduct';
  brand?: Maybe<Brand>;
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price: Pricing;
  /** Image displayed in the carousel */
  primaryImage: ProductImage;
  /** Image displayed on hover, currently only used on web */
  secondaryImage?: Maybe<ProductImage>;
  /**
   * The variant the carousel resolves to, and whether a choice is still pending.
   * Computed by ceres-catalog from the identifier the carousel was queried with:
   *
   * - Sku with no other variant of the same color          -> FINAL
   * - Sku of a product without colors, with more variants  -> NONE
   * - Sku with more variants of the same color             -> COLOR
   * - Master code, and the product has more than one size  -> NONE
   * - Master code, and the product has a single size       -> FINAL
   *
   * A product without colors counts as one color. When a requested sku is sold out,
   * NONE and COLOR swap it for the first available variant of the same color, and
   * keep it when none of them is available. Master code sizes are counted over all
   * variants, sold out or not.
   *
   * This exists so a carousel never links to a specific size the shopper didn't
   * choose (a driver of avoidable returns) while still resolving a concrete,
   * indexable variant for SEO/tracking purposes.
   */
  selection: ProductSelection;
  signings?: Maybe<SigningsV2>;
  size?: Maybe<Scalars['String']['output']>;
  subBrand?: Maybe<Brand>;
  trackingMetadata: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

export type CategoryPathNode = {
  __typename?: 'CategoryPathNode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum Channel {
  /** A mobile or tablet device using the native application. */
  App = 'APP',
  /** A device accessing the platform via a web browser. */
  Web = 'WEB',
}

export type ColorOption = {
  /** Whether at least one variant or single variant of this color option is available for purchase */
  available?: Maybe<Scalars['Boolean']['output']>;
  /** Color swatch image of this color option */
  image: ProductImage;
  /** If this option has only one selectable size, this links directly to that SKU, otherwise it links to the PDP of this color option */
  url: Scalars['String']['output'];
};

export enum ColorOptionDisplayType {
  Swatch = 'SWATCH',
  Thumbnail = 'THUMBNAIL',
}

export type ColorOptions = {
  displayType: ColorOptionDisplayType;
  options: Array<ColorOption>;
};

export enum ContentFormat {
  Html = 'HTML',
  Markdown = 'MARKDOWN',
}

export enum DeliveryTime {
  ExternalSupplierDependent = 'EXTERNAL_SUPPLIER_DEPENDENT',
  Immediately = 'IMMEDIATELY',
  MaxFiveDays = 'MAX_FIVE_DAYS',
  NextDay = 'NEXT_DAY',
  NotAvailable = 'NOT_AVAILABLE',
}

export type DetailAlternativeLanguage = AlternativeUrl & {
  __typename?: 'DetailAlternativeLanguage';
  locale: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DetailPageMetaInformation = {
  __typename?: 'DetailPageMetaInformation';
  alternativeLanguages: Array<DetailAlternativeLanguage>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DetailPageMetaInformationV2 = {
  __typename?: 'DetailPageMetaInformationV2';
  alternativeLanguages: Array<DetailAlternativeLanguage>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum DetailPageVariation {
  Bundled = 'BUNDLED',
  Cosmetics = 'COSMETICS',
  Giftcard = 'GIFTCARD',
}

export type DisplayedPrice = {
  __typename?: 'DisplayedPrice';
  /** Optional text shown with the price; for example 'Originele prijs', 'Adviesprijs' or 'Vorige laagste prijs' */
  label?: Maybe<Scalars['String']['output']>;
  /** Whether to show the price with a strike-through */
  strikeThrough: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export type EditorsNote = {
  __typename?: 'EditorsNote';
  editorName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests
   * Error Type: UNAVAILABLE
   */
  TooManyRequests = 'TOO_MANY_REQUESTS',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN',
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN',
}

export type Feature = {
  /**  The experimental sub-group for the feature, if needed */
  group?: InputMaybe<Scalars['String']['input']>;
  /**  The name of the feature to enable */
  name: Scalars['String']['input'];
  /**  The origin of the feature/experiment */
  source?: InputMaybe<FeatureSource>;
};

export enum FeatureSource {
  Default = 'DEFAULT',
  FilterExperiment = 'FILTER_EXPERIMENT',
}

export type Filter = {
  __typename?: 'Filter';
  id?: Maybe<Scalars['ID']['output']>;
  internalName: Scalars['String']['output'];
  layoutProperties: FilterLayoutProperties;
  name: Scalars['String']['output'];
  /**
   *  Refinements ranked by popularity, ordered most popular first
   *  Null if popularity data is unavailable for this filter
   */
  popularRefinements?: Maybe<Array<Refinement>>;
  refinements: Array<Refinement>;
  removeQuery?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
  visible: Scalars['Boolean']['output'];
};

export type FilterLayoutProperties = {
  __typename?: 'FilterLayoutProperties';
  contextualRefinements?: Maybe<Array<Refinement>>;
  expanded: Scalars['Boolean']['output'];
  multiColumn: Scalars['Boolean']['output'];
  searchable: Scalars['Boolean']['output'];
  selectedRangeMax?: Maybe<Scalars['Int']['output']>;
  selectedRangeMin?: Maybe<Scalars['Int']['output']>;
  seoIndexable: Scalars['Boolean']['output'];
  slider: Scalars['Boolean']['output'];
  swatches: Scalars['Boolean']['output'];
  type: Scalars['Boolean']['output'];
  validRangeMax?: Maybe<Scalars['Int']['output']>;
  validRangeMin?: Maybe<Scalars['Int']['output']>;
  visibleOnBanner: Scalars['Boolean']['output'];
};

export type FilterLayoutPropertiesV2 = {
  __typename?: 'FilterLayoutPropertiesV2';
  expanded: Scalars['Boolean']['output'];
  multiColumn: Scalars['Boolean']['output'];
  searchable: Scalars['Boolean']['output'];
  selectedRange?: Maybe<Range>;
  seoIndexable: Scalars['Boolean']['output'];
  slider: Scalars['Boolean']['output'];
  swatches: Scalars['Boolean']['output'];
  validRange?: Maybe<Range>;
};

/**
 * The catalog already leaves hidden filters out of the response, so there is no `visible` flag
 * like the one on `Filter`.
 */
export type FilterV2 = {
  __typename?: 'FilterV2';
  id?: Maybe<Scalars['ID']['output']>;
  internalName: Scalars['String']['output'];
  layoutProperties: FilterLayoutPropertiesV2;
  name: Scalars['String']['output'];
  parentQuery?: Maybe<Scalars['String']['output']>;
  /** A refinement can only appear in exactly one group depending on the group priority. */
  refinementGroups: Array<RefinementGroup>;
  selected: Scalars['Boolean']['output'];
};

export type Fit = {
  __typename?: 'Fit';
  attributes?: Maybe<Array<ProductAttribute>>;
  sizeTableId?: Maybe<Scalars['String']['output']>;
};

export type FocusPoint = {
  __typename?: 'FocusPoint';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type Footer = {
  __typename?: 'Footer';
  links?: Maybe<Array<Link>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
};

export enum GroupByAttribute {
  Color = 'COLOR',
  Size = 'SIZE',
}

export type Header = {
  __typename?: 'Header';
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  href: Scalars['String']['output'];
  type: ImageType;
};

export type ImageCollection = {
  __typename?: 'ImageCollection';
  id: Scalars['ID']['output'];
  urls: Array<Scalars['String']['output']>;
};

export type ImageModel = {
  __typename?: 'ImageModel';
  alt?: Maybe<Scalars['String']['output']>;
  focusPoint?: Maybe<FocusPoint>;
  src?: Maybe<Scalars['String']['output']>;
};

export enum ImageType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Thumbnail = 'THUMBNAIL',
}

export type Ingredients = {
  __typename?: 'Ingredients';
  text?: Maybe<Scalars['String']['output']>;
};

export type Link = {
  __typename?: 'Link';
  href: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ListerAlternativeLanguage = AlternativeUrl & {
  __typename?: 'ListerAlternativeLanguage';
  locale: Scalars['String']['output'];
  query: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ListerPageMetaInformation = {
  __typename?: 'ListerPageMetaInformation';
  alternativeLanguages: Array<ListerAlternativeLanguage>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  query: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ListerPageMetaInformationV2 = {
  __typename?: 'ListerPageMetaInformationV2';
  alternativeLanguages: Array<ListerAlternativeLanguage>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  query: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Localization = {
  __typename?: 'Localization';
  /** The native name of the country queried, e.g. England, Deutchland or Nederland. */
  countryName: Scalars['String']['output'];
  /** A JSON dictionary with labels that can be used in the user interface */
  labels?: Maybe<Scalars['JSON']['output']>;
  /** The native name of the language queried, e.g. English, Deutsch or Nederlands. */
  languageName: Scalars['String']['output'];
  /** The normalized form of the locale queried. */
  locale: Scalars['String']['output'];
};

export type MerchandisingTile = {
  __typename?: 'MerchandisingTile';
  content?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ImageModel>;
  title?: Maybe<Scalars['String']['output']>;
  trackingPath: Scalars['String']['output'];
};

export type MerchandisingTileContentArgs = {
  format?: InputMaybe<ContentFormat>;
};

export type Navigation = {
  __typename?: 'Navigation';
  breadcrumbs: Array<Breadcrumb>;
  filters: Array<Filter>;
  pagination?: Maybe<Pagination>;
  products: Array<Product>;
  promotions?: Maybe<Array<Promotion>>;
  rankings?: Maybe<Array<Scalars['String']['output']>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  relatedQueries?: Maybe<Array<Scalars['String']['output']>>;
  searchText?: Maybe<SearchText>;
  sortOptions?: Maybe<Array<SortOption>>;
  trackingMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type OffCanvasPanel = {
  __typename?: 'OffCanvasPanel';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: OffCanvasPanelType;
};

export type OffCanvasPanelContentArgs = {
  format?: InputMaybe<ContentFormat>;
};

export enum OffCanvasPanelType {
  Sizetable = 'SIZETABLE',
}

export type OpeningHours = {
  __typename?: 'OpeningHours';
  date: Scalars['String']['output'];
  timeRange?: Maybe<TimeRange>;
};

export type OriginalPrice = {
  __typename?: 'OriginalPrice';
  original: DisplayedPrice;
};

export type Page = {
  __typename?: 'Page';
  pageNumber: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
};

export type PageV2 = {
  __typename?: 'PageV2';
  number: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
};

export type Pagination = {
  __typename?: 'Pagination';
  currentPage: Page;
  nextPage?: Maybe<Page>;
  previousPage?: Maybe<Page>;
  startIndex: Scalars['Int']['output'];
  totalItemCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  viewSize: Scalars['Int']['output'];
};

export type PaginationV2 = {
  __typename?: 'PaginationV2';
  current: PageV2;
  next?: Maybe<PageV2>;
  previous?: Maybe<PageV2>;
  startIndex: Scalars['Int']['output'];
  totalItemCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
  viewSize: Scalars['Int']['output'];
};

export type PdpColorOption = ColorOption & {
  __typename?: 'PdpColorOption';
  available: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  image: ProductImage;
  selected: Scalars['Boolean']['output'];
  /** Only populated if this color option is available with at least one defined size */
  sizeOptions?: Maybe<SizeOptions>;
  /** Populated if this color option represents a single variant. */
  sku?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PdpColorOptions = ColorOptions & {
  __typename?: 'PdpColorOptions';
  displayType: ColorOptionDisplayType;
  hasSizeOptions: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<PdpColorOption>;
  /** An optional text that can be used to display as a hint when no selection has been made yet */
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type PlpColorOption = ColorOption & {
  __typename?: 'PlpColorOption';
  available?: Maybe<Scalars['Boolean']['output']>;
  image: ProductImage;
  url: Scalars['String']['output'];
};

export type PlpColorOptions = ColorOptions & {
  __typename?: 'PlpColorOptions';
  displayType: ColorOptionDisplayType;
  options: Array<PlpColorOption>;
};

export type PreviousLowestAndOriginalPrice = {
  __typename?: 'PreviousLowestAndOriginalPrice';
  original: DisplayedPrice;
  previousLowest: DisplayedPrice;
};

export type Price = {
  __typename?: 'Price';
  currencyCode: Scalars['String']['output'];
  type: PriceType;
  value: Scalars['Float']['output'];
};

export type PriceDetails =
  | OriginalPrice
  | PreviousLowestAndOriginalPrice
  | RecommendedAndOriginalPrice
  | RecommendedPrice;

export enum PriceType {
  AvailableFrom = 'AVAILABLE_FROM',
  List = 'LIST',
  Lowest = 'LOWEST',
  Recommended = 'RECOMMENDED',
  Sales = 'SALES',
  Special = 'SPECIAL',
  Total = 'TOTAL',
}

export type Pricing = {
  __typename?: 'Pricing';
  /** Currency code in ISO-4217 format */
  currencyCode: Scalars['String']['output'];
  /** Complementary pricing details */
  details?: Maybe<PriceDetails>;
  /**
   * Optional text shown before the price.
   *
   * For example, this can be used to render prices such as "vanaf €45,-",
   * where "vanaf" is the label.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Whether to show the main price discounted (purple) or not (black, default)) */
  showPriceDiscounted?: Maybe<Scalars['Boolean']['output']>;
  /** The main price to display */
  value: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  accordions?: Maybe<Array<Accordion>>;
  archived: Scalars['Boolean']['output'];
  /** @deprecated Please use 'accordions' */
  attributeGroups?: Maybe<Array<AttributeGroup>>;
  availableFromPrice?: Maybe<Price>;
  brand?: Maybe<Brand>;
  categoryPath: Array<CategoryPathNode>;
  code: Scalars['String']['output'];
  colorCount: Scalars['Int']['output'];
  createdOn: Scalars['Float']['output'];
  currentVariantProduct: VariantProduct;
  defaultVariantCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designer: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  displayProperties: ProductDisplayProperties;
  editorsNote?: Maybe<EditorsNote>;
  fitMessage?: Maybe<Scalars['String']['output']>;
  gift: Scalars['Boolean']['output'];
  /**
   * Attribute to be removed on Ticket WD-56960
   * @deprecated Please use 'accordions'
   */
  groupedAttributes: Array<ProductAttributeGroup>;
  name?: Maybe<Scalars['String']['output']>;
  recommendationRanking: Scalars['Float']['output'];
  relatedProducts: Array<RelatedProducts>;
  shipping?: Maybe<Shipping>;
  shippingType: ShippingType;
  similarItems: Array<SimilarProductsLink>;
  subBrand?: Maybe<Brand>;
  supplierModel?: Maybe<SupplierModel>;
  sustainabilityInfo?: Maybe<Array<Maybe<SustainabilityInfo>>>;
  sustainabilityOCP?: Maybe<SustainabilityOcp>;
  sustainable: Scalars['Boolean']['output'];
  trackingMetadata: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
  variantProducts: Array<VariantProduct>;
  videos?: Maybe<Array<Maybe<Video>>>;
};

export type ProductVariantProductsArgs = {
  groupBy?: InputMaybe<GroupByAttribute>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type ProductAttributeGroup = {
  __typename?: 'ProductAttributeGroup';
  attributes: Array<ProductAttribute>;
  id: Scalars['ID']['output'];
};

/** Exposes additional product and variant data. */
export type ProductData = {
  __typename?: 'ProductData';
  availability: Availability;
  /**
   * Whether the current selection can lead to a basket add. Depends on the selection mode:
   * - FINAL: the selected variant is available for purchase
   * - COLOR: at least one variant in the selected color group is available
   * - NONE: at least one variant is available
   */
  availableForBasket: Scalars['Boolean']['output'];
  brand?: Maybe<Brand>;
  categoryPath: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  deliveryTime: DeliveryTime;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  features: Array<ProductFeature>;
  fitMessage?: Maybe<Scalars['String']['output']>;
  images: Array<ProductImage>;
  name?: Maybe<Scalars['String']['output']>;
  price: Pricing;
  /**
   * The quantity selector for this product: the label/placeholder to render and the range the customer can
   * order at once, from the minimum order quantity (usually 1) up to a maximum. Null when the product has no
   * quantity selector.
   */
  quantitySelection?: Maybe<QuantitySelection>;
  relatedProducts?: Maybe<Array<RelatedProducts>>;
  selection: ProductSelection;
  /**  Note: This merges product and selected variant trackingMetadata */
  shipping: Shipping;
  signings: SigningsV2;
  similarItems?: Maybe<Array<SimilarProductsLink>>;
  size?: Maybe<Scalars['String']['output']>;
  subBrand?: Maybe<Brand>;
  trackingMetadata: Scalars['JSON']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** Use case for this field is the JSON-LD that SSR needs to populate. It shouldn't be necessary otherwise! */
  variants?: Maybe<VariantOptions>;
  videos?: Maybe<Array<Video>>;
};

export type ProductDescription = {
  __typename?: 'ProductDescription';
  text?: Maybe<Scalars['String']['output']>;
};

export type ProductDetails = {
  __typename?: 'ProductDetails';
  merchandisingTile?: Maybe<MerchandisingTile>;
  metaInformation?: Maybe<DetailPageMetaInformation>;
  navigation: Navigation;
  product: Product;
  ribbon?: Maybe<Ribbon>;
};

/** Component-oriented view of the product-detail-page */
export type ProductDetailsPage = {
  __typename?: 'ProductDetailsPage';
  /**
   * Expandable content sections for the product-detail page: product description, washing
   * instructions, composition & specifications, ingredients, fit and return-old-product. Built from
   * the product's description, its flat attribute list (grouped in luna) and the size-table content
   * reference.
   */
  accordions?: Maybe<Array<Accordion>>;
  breadcrumbs: Array<BreadcrumbV2>;
  merchandisingTile?: Maybe<MerchandisingTile>;
  metaInformation?: Maybe<DetailPageMetaInformationV2>;
  product: ProductData;
  ribbon?: Maybe<Ribbon>;
  sizeTable?: Maybe<SizeTable>;
  usps?: Maybe<Array<Usp>>;
};

export type ProductDisplayProperties = {
  __typename?: 'ProductDisplayProperties';
  attributesDisplayMode?: Maybe<AttributesDisplayMode>;
  currentVariantSelected: Scalars['Boolean']['output'];
  detailPageVariation?: Maybe<DetailPageVariation>;
  showQuantity: Scalars['Boolean']['output'];
};

export enum ProductFeature {
  GiftCard = 'GIFT_CARD',
  GiftWithPurchase = 'GIFT_WITH_PURCHASE',
  OnlineOnly = 'ONLINE_ONLY',
  SendFromStore = 'SEND_FROM_STORE',
}

export enum ProductIdentifierType {
  /**  10 Digit product code */
  Master = 'MASTER',
  /**  15 Digit SKU */
  Variant = 'VARIANT',
}

export type ProductImage = {
  __typename?: 'ProductImage';
  position: Scalars['Int']['output'];
  type: ProductImageType;
  url: Scalars['String']['output'];
};

export enum ProductImageType {
  Back = 'BACK',
  Detail = 'DETAIL',
  Front = 'FRONT',
  Other = 'OTHER',
}

export type ProductListing = {
  __typename?: 'ProductListing';
  banners: Array<Banner>;
  footerLinks?: Maybe<Array<Link>>;
  footerText?: Maybe<Scalars['String']['output']>;
  footerTitle?: Maybe<Scalars['String']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  headerTitle?: Maybe<Scalars['String']['output']>;
  metaInformation: ListerPageMetaInformation;
  navigation: Navigation;
  ribbon?: Maybe<Ribbon>;
  trackingMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type ProductListingPage = ProductNavigation & {
  __typename?: 'ProductListingPage';
  banners: Array<Banner>;
  breadcrumbs: Array<BreadcrumbV2>;
  filters: Array<FilterV2>;
  footer?: Maybe<Footer>;
  header?: Maybe<Header>;
  metaInformation: ListerPageMetaInformationV2;
  pagination?: Maybe<PaginationV2>;
  products: Array<ProductListingProduct>;
  ribbon?: Maybe<Ribbon>;
  sortOptions?: Maybe<Array<SortOptionV2>>;
  trackingMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type ProductListingProduct = {
  __typename?: 'ProductListingProduct';
  brand?: Maybe<Brand>;
  categoryPath: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  /**  Color options available for this product on the PLP */
  colors: PlpColorOptions;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price: Pricing;
  /**  Image displayed in the listing */
  primaryImage: ProductImage;
  /**  Another image displayed on mouse hover only available for web now */
  secondaryImage?: Maybe<ProductImage>;
  selection: ProductSelection;
  signings?: Maybe<SigningsV2>;
  subBrand?: Maybe<Brand>;
  trackingMetadata: Scalars['JSON']['output'];
  /**  This URL depends on the color and size refinement selection */
  url: Scalars['String']['output'];
};

export type ProductNavigation = {
  banners: Array<Banner>;
  breadcrumbs: Array<BreadcrumbV2>;
  filters: Array<FilterV2>;
  footer?: Maybe<Footer>;
  header?: Maybe<Header>;
  metaInformation: ListerPageMetaInformationV2;
  pagination?: Maybe<PaginationV2>;
  products: Array<ProductListingProduct>;
  ribbon?: Maybe<Ribbon>;
  sortOptions?: Maybe<Array<SortOptionV2>>;
  trackingMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type ProductRecommendation = {
  __typename?: 'ProductRecommendation';
  category: Scalars['String']['output'];
  products: Array<Product>;
};

export type ProductRecommendations = {
  __typename?: 'ProductRecommendations';
  modelVariant?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  testId?: Maybe<Scalars['String']['output']>;
  trackingMetadata?: Maybe<Scalars['JSON']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

export type ProductSearchPage = ProductNavigation & {
  __typename?: 'ProductSearchPage';
  banners: Array<Banner>;
  breadcrumbs: Array<BreadcrumbV2>;
  filters: Array<FilterV2>;
  footer?: Maybe<Footer>;
  header?: Maybe<Header>;
  metaInformation: ListerPageMetaInformationV2;
  pagination?: Maybe<PaginationV2>;
  products: Array<ProductListingProduct>;
  resolution: SearchResolution;
  ribbon?: Maybe<Ribbon>;
  sortOptions?: Maybe<Array<SortOptionV2>>;
  trackingMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type ProductSearchResult = ProductSearchPage | Redirect;

export type ProductSelection = {
  __typename?: 'ProductSelection';
  mode: SelectionMode;
  sku: Scalars['String']['output'];
};

export type ProductStoreStock = {
  __typename?: 'ProductStoreStock';
  status: StockStatus;
  stock: Scalars['Int']['output'];
  stockStatusDescription?: Maybe<Scalars['String']['output']>;
  store: StoreInformation;
};

export type Promotion = {
  __typename?: 'Promotion';
  componentId?: Maybe<Scalars['ID']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type QuantitySelection = {
  __typename?: 'QuantitySelection';
  /** A display label that can be shown in front of a quantity selector. */
  label: Scalars['String']['output'];
  /** Maximum quantity the customer can select. */
  maximum: Scalars['Int']['output'];
  /** Minimum quantity the customer can select, which is usually 1. */
  minimum: Scalars['Int']['output'];
  /** A text that can be used to display as a hint when no selection has been made yet */
  placeholder: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  carouselProducts: Array<CarouselProduct>;
  localization?: Maybe<Localization>;
  nearestNeighbourProducts?: Maybe<ProductRecommendations>;
  offCanvasPanel?: Maybe<OffCanvasPanel>;
  productDetails?: Maybe<ProductDetails>;
  productDetailsPage?: Maybe<ProductDetailsPage>;
  /** @deprecated Use productListingPage instead. Cleanup: WD-58837 */
  productListing?: Maybe<ProductListing>;
  productListingPage?: Maybe<ProductListingPage>;
  /** @deprecated Use productSearchPage instead. Cleanup: WD-58837 */
  productListingSearch?: Maybe<ProductListing>;
  /** @deprecated This query is going to be removed soon */
  productRecommendations?: Maybe<ProductRecommendations>;
  productSearchPage?: Maybe<ProductSearchResult>;
  productStoreStock: Array<Maybe<ProductStoreStock>>;
  products?: Maybe<Array<Product>>;
  recommendedProducts: Array<CarouselProduct>;
  visualSimilarProducts?: Maybe<ProductRecommendations>;
};

export type QueryCarouselProductsArgs = {
  features?: InputMaybe<Array<Feature>>;
  identifiers: Array<Scalars['ProductIdentifier']['input']>;
  locale?: Scalars['Locale']['input'];
};

export type QueryLocalizationArgs = {
  baseNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flatten?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type QueryNearestNeighbourProductsArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  testId?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOffCanvasPanelArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['Locale']['input']>;
  type: OffCanvasPanelType;
};

export type QueryProductDetailsArgs = {
  ean?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Feature>>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productVariantCode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductDetailsPageArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Feature>>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductListingArgs = {
  channel?: Channel;
  features?: InputMaybe<Array<Feature>>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  query: Scalars['String']['input'];
  topProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  variationType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductListingPageArgs = {
  channel?: Channel;
  features?: InputMaybe<Array<Feature>>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  query: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  variation?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductListingSearchArgs = {
  channel?: Channel;
  features?: InputMaybe<Array<Feature>>;
  keywords: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['Locale']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryProductRecommendationsArgs = {
  category?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryProductSearchPageArgs = {
  channel?: Channel;
  features?: InputMaybe<Array<Feature>>;
  keyword: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['Locale']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  variation?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProductStoreStockArgs = {
  productVariantCode: Scalars['String']['input'];
};

export type QueryProductsArgs = {
  features?: InputMaybe<Array<Feature>>;
  identifierType: ProductIdentifierType;
  identifiers: Array<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type QueryRecommendedProductsArgs = {
  features?: InputMaybe<Array<Feature>>;
  locale?: Scalars['Locale']['input'];
  sku: Scalars['String']['input'];
  type: RecommendationType;
};

export type QueryVisualSimilarProductsArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  testId?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** The outcome of query resolution, independent of search engine internals. */
export enum QueryResolutionType {
  /** No direct match, alternative searches are offered (alternatives is populated). */
  Alternatives = 'ALTERNATIVES',
  /** The query matched directly without modification. */
  Direct = 'DIRECT',
  /** An unrecognized or future resolution mechanism. */
  Other = 'OTHER',
  /** The query was spell-corrected (correctedKeyword is populated). */
  SpellingCorrection = 'SPELLING_CORRECTION',
}

export type Range = {
  __typename?: 'Range';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export enum RecommendationType {
  OthersAlsoViewed = 'OTHERS_ALSO_VIEWED',
  VisuallySimilar = 'VISUALLY_SIMILAR',
}

export type RecommendedAndOriginalPrice = {
  __typename?: 'RecommendedAndOriginalPrice';
  original: DisplayedPrice;
  recommended: DisplayedPrice;
};

export type RecommendedPrice = {
  __typename?: 'RecommendedPrice';
  recommended: DisplayedPrice;
};

export type Redirect = {
  __typename?: 'Redirect';
  redirectUrl: Scalars['String']['output'];
};

export type Refinement = {
  __typename?: 'Refinement';
  childIds: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noFollow: Scalars['Boolean']['output'];
  query?: Maybe<Scalars['String']['output']>;
  rangeMax?: Maybe<Scalars['Int']['output']>;
  rangeMin?: Maybe<Scalars['Int']['output']>;
  refinementCount: Scalars['Int']['output'];
  relativeUrl?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
};

export type RefinementGroup = {
  __typename?: 'RefinementGroup';
  /** Display ready and already localised. Render it as it comes, or render no heading when it is null. */
  label?: Maybe<Scalars['String']['output']>;
  refinements: Array<RefinementV2>;
  type: RefinementGroupType;
};

export enum RefinementGroupType {
  Favorite = 'FAVORITE',
  General = 'GENERAL',
  Popular = 'POPULAR',
}

export type RefinementV2 = {
  __typename?: 'RefinementV2';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  range?: Maybe<Range>;
  refinementCount: Scalars['Int']['output'];
  relativeUrl?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
};

export type RelatedProducts = {
  __typename?: 'RelatedProducts';
  codes: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReturnOldProduct = {
  __typename?: 'ReturnOldProduct';
  link?: Maybe<Link>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Ribbon = {
  __typename?: 'Ribbon';
  cta?: Maybe<Link>;
  /** Known values: `Store` */
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  /** Known values: `default` | `urgent` | `sale-1` | `sale-2` | `sale-3` */
  variant?: Maybe<Scalars['String']['output']>;
};

export type SearchAlternative = {
  __typename?: 'SearchAlternative';
  corrected?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  query: Scalars['String']['output'];
  totalItemCount: Scalars['Int']['output'];
};

/**
 * Describes how a search query was resolved when it did not (fully) match:
 * spell-corrected (e.g. adibas -> adidas) and/or broadened into alternative
 * search suggestions.
 */
export type SearchResolution = {
  __typename?: 'SearchResolution';
  /** The spell-corrected keyword, present only when a correction was applied. */
  correctedKeyword?: Maybe<Scalars['String']['output']>;
  /** The search keyword as originally entered by the user. */
  keyword: Scalars['String']['output'];
  /** How the search engine resolved the query. */
  resolutionType: QueryResolutionType;
  /** Alternative searches offered when no direct results were found. Empty when not applicable. */
  suggestions: Array<SearchSuggestion>;
};

/** A single alternative search suggestion, including a preview of its results. */
export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  /** Correction applied to the alternative keyword itself, if any. */
  correctedKeyword?: Maybe<Scalars['String']['output']>;
  /** The alternative keyword to display to the user. */
  keyword: Scalars['String']['output'];
  /** The ready-to-execute query string for this alternative. */
  searchQuery: Scalars['String']['output'];
  /** A list of SKUs matching this alternative, for product carousels */
  skus: Array<Scalars['String']['output']>;
  /** Total number of items this alternative would return. */
  totalItemCount: Scalars['Int']['output'];
};

export type SearchText = {
  __typename?: 'SearchText';
  alternatives?: Maybe<Array<SearchAlternative>>;
  corrected?: Maybe<Scalars['String']['output']>;
  original: Scalars['String']['output'];
  searchPass: Scalars['String']['output'];
};

export enum SelectionMode {
  /** A color has been selected, but a size selection is still required. */
  Color = 'COLOR',
  /** The product choice is unambiguous, no further variant selection is required. */
  Final = 'FINAL',
  /** No color-specific selection is active and a size selection is still required. */
  None = 'NONE',
}

export type ServerInfo = {
  __typename?: 'ServerInfo';
  environment: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Shipping = {
  __typename?: 'Shipping';
  alert?: Maybe<Scalars['String']['output']>;
  delivery?: Maybe<Scalars['String']['output']>;
  deliveryLinks: Array<Link>;
  returnType?: Maybe<ShippingReturnType>;
  returns?: Maybe<Scalars['String']['output']>;
  returnsLinks: Array<Link>;
  supplier?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ShippingDeliveryArgs = {
  format?: InputMaybe<ContentFormat>;
};

export type ShippingReturnsArgs = {
  format?: InputMaybe<ContentFormat>;
};

export enum ShippingReturnType {
  Normal = 'NORMAL',
  NoReturns = 'NO_RETURNS',
  Other = 'OTHER',
}

export enum ShippingType {
  Digital = 'DIGITAL',
  Dropshipper = 'DROPSHIPPER',
  Fragile = 'FRAGILE',
  ManualDropshipper = 'MANUAL_DROPSHIPPER',
  None = 'NONE',
  Standard = 'STANDARD',
}

export type ShopTheItems = {
  __typename?: 'ShopTheItems';
  suggestedProducts?: Maybe<Array<CarouselProduct>>;
};

export type ShopTheLook = {
  __typename?: 'ShopTheLook';
  code?: Maybe<Scalars['String']['output']>;
  suggestedProductCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type Signing = {
  __typename?: 'Signing';
  key?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Signings = {
  __typename?: 'Signings';
  discount: Array<Signing>;
  merchandise: Array<Signing>;
};

export type SigningsV2 = {
  __typename?: 'SigningsV2';
  discount?: Maybe<Scalars['String']['output']>;
  merchandise?: Maybe<Array<Scalars['String']['output']>>;
};

export type SimilarProductsLink = {
  __typename?: 'SimilarProductsLink';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  relativeUrl?: Maybe<Scalars['String']['output']>;
};

/**  NOTE: This may represent different kinds of sizes (clothing sizes, volumes, money, etc.) */
export type SizeOption = {
  __typename?: 'SizeOption';
  available: Scalars['Boolean']['output'];
  selected: Scalars['Boolean']['output'];
  size: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SizeOptions = {
  __typename?: 'SizeOptions';
  /**
   * A display label that can be shown in front of a size selector. For clothing this is usually "Maat" (size). For other
   * product types this can describe a different kind of choice, such as "Inhoud" (volume) or "Waarde" for gift card value.
   */
  label: Scalars['String']['output'];
  options: Array<SizeOption>;
  /** An optional text that can be used to display as a hint when no selection has been made yet */
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type SizeTable = {
  __typename?: 'SizeTable';
  /** Requires an extra call on ContentStack to fetch this information. Don't request it in case you consider lazy loading the size-table */
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type SizeTableContentArgs = {
  format?: InputMaybe<ContentFormat>;
};

export type SortOption = {
  __typename?: 'SortOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  noFollow: Scalars['Boolean']['output'];
  query: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type SortOptionV2 = {
  __typename?: 'SortOptionV2';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  query: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export enum StockStatus {
  InStock = 'IN_STOCK',
  NotSoldInStore = 'NOT_SOLD_IN_STORE',
  OutOfStock = 'OUT_OF_STOCK',
  Unknown = 'UNKNOWN',
}

export type Store = {
  __typename?: 'Store';
  address: Address;
  alert?: Maybe<StoreContenLink>;
  businessHours: BusinessHours;
  events: Array<StoreEvent>;
  geoLocation: GeoLocation;
  id: Scalars['Int']['output'];
  images: Array<Image>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingHours: Array<StoreOpeningHours>;
  parkingDetails?: Maybe<StoreContenLink>;
};

export type StoreAddress = {
  __typename?: 'StoreAddress';
  cityName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type StoreContenLink = {
  __typename?: 'StoreContenLink';
  description?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StoreEvent = {
  __typename?: 'StoreEvent';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  images: Array<Image>;
  link: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type StoreInformation = {
  __typename?: 'StoreInformation';
  address?: Maybe<StoreAddress>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingHours?: Maybe<Array<OpeningHours>>;
};

export type StoreOpeningHours = {
  __typename?: 'StoreOpeningHours';
  current: Scalars['Boolean']['output'];
  times?: Maybe<Scalars['JSON']['output']>;
  weekNumber: Scalars['Int']['output'];
};

export type StoreStock = {
  __typename?: 'StoreStock';
  status: StockStatus;
  stock: Scalars['Int']['output'];
  store: Store;
};

export enum SupplierModel {
  AutoDropshipper = 'AUTO_DROPSHIPPER',
  Concession = 'CONCESSION',
  Consignment = 'CONSIGNMENT',
  Digital = 'DIGITAL',
  Dropshipper = 'DROPSHIPPER',
  ManualDropshipper = 'MANUAL_DROPSHIPPER',
  Wholesale = 'WHOLESALE',
}

export type SustainabilityInfo = {
  __typename?: 'SustainabilityInfo';
  characteristicsText?: Maybe<Scalars['String']['output']>;
  characteristicsTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  impactList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type SustainabilityItem = {
  __typename?: 'SustainabilityItem';
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SustainabilityType>;
};

export type SustainabilityOcp = {
  __typename?: 'SustainabilityOCP';
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<SustainabilityItem>>>;
};

export enum SustainabilityType {
  Certificate = 'CERTIFICATE',
  Goal = 'GOAL',
}

export type TimeRange = {
  __typename?: 'TimeRange';
  from: Scalars['String']['output'];
  until: Scalars['String']['output'];
};

export type UnitPrice = {
  __typename?: 'UnitPrice';
  quantity: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Usp = {
  __typename?: 'Usp';
  text: Scalars['String']['output'];
  type: UspType;
};

export enum UspType {
  DeliveryInfo = 'DELIVERY_INFO',
  LeadTime = 'LEAD_TIME',
  ReturnInfo = 'RETURN_INFO',
  SendFromStore = 'SEND_FROM_STORE',
  StoreStock = 'STORE_STOCK',
}

export type VariantOptions = PdpColorOptions | SizeOptions;

export type VariantProduct = {
  __typename?: 'VariantProduct';
  /** @deprecated Default value is 'false'. Please remove it */
  archived: Scalars['Boolean']['output'];
  availability: Availability;
  bundleSet: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  current: Scalars['Boolean']['output'];
  deliveryTime: DeliveryTime;
  eligibleForSendFromStore: Scalars['Boolean']['output'];
  imageCollections?: Maybe<Array<Maybe<ImageCollection>>>;
  images: Array<ProductImage>;
  lowestPrice?: Maybe<Price>;
  lowestPriceFlag: Scalars['Boolean']['output'];
  minOrderQuantity: Scalars['Int']['output'];
  overriddenPrices: Array<Price>;
  relatedProducts: Array<RelatedProducts>;
  retailSet: Scalars['Boolean']['output'];
  selectionImage: ProductImage;
  sellingPrice: Price;
  signings: Signings;
  size?: Maybe<Scalars['String']['output']>;
  trackingMetadata: Scalars['JSON']['output'];
  unitPrice?: Maybe<UnitPrice>;
  url?: Maybe<Scalars['String']['output']>;
  usps?: Maybe<Array<Usp>>;
};

export type VariantShopTheLook = {
  __typename?: 'VariantShopTheLook';
  variants?: Maybe<Array<ShopTheLook>>;
};

export type Video = {
  __typename?: 'Video';
  id: Scalars['ID']['output'];
  parameters?: Maybe<Array<Maybe<VideoParameters>>>;
  type: VideoType;
};

export type VideoParameters = {
  __typename?: 'VideoParameters';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum VideoType {
  Vimeo = 'VIMEO',
}

export type WashingInstructions = {
  __typename?: 'WashingInstructions';
  attributes?: Maybe<Array<ProductAttribute>>;
};

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String']['output'];
};
